import {
  type AccountData,
  type AccountUpdateBatchInput,
  type AccountUpdateBatchSuccess,
  toResponseError,
} from '@terros/common'
import { useWidgetCache } from '../widget'
import { useTantalimMutation } from '../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useAccountCache } from './cache'

export function useUpdateAccountBatch(): UpdateHookResponse<AccountUpdateBatchInput['accounts'], AccountData[]> {
  const { updateItem, clearList } = useAccountCache()
  const widgetCache = useWidgetCache()

  const mutation = useTantalimMutation<AccountUpdateBatchInput, AccountUpdateBatchSuccess>({
    url: '/account/update/batch',
  })

  async function update(accounts: AccountUpdateBatchInput['accounts']): Promise<AccountData[]> {
    try {
      const data = await mutation.mutateAsync({ accounts })
      const updatedAccounts = data.accounts
      updatedAccounts.forEach(updateItem)
      widgetCache.clearWidgets()
      widgetCache.clearList()
      setTimeout(() => {
        clearList()
      }, 1000)
      return updatedAccounts
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
